import { render } from "./ArtifactUploadModal.vue?vue&type=template&id=be2d9844&scoped=true"
import script from "./ArtifactUploadModal.vue?vue&type=script&lang=js"
export * from "./ArtifactUploadModal.vue?vue&type=script&lang=js"

import "./ArtifactUploadModal.vue?vue&type=style&index=0&id=be2d9844&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2d9844"]])

export default __exports__